import styled from 'styled-components';

export const journeyManagedStyles = (Component) => styled(Component)`
  .title {
    font-weight: bolder;
    color: var(--grey500);
    text-transform: uppercase;
    margin: 1.2rem 0 0.4rem 0;
  }

  .tag {
    height: 24px;
    padding: 0 8px;
    line-height: 24px;
    font-weight: bold;
    border-radius: 2px;
    display: inline-block;
    text-transform: uppercase;
  }

  .driver {
    color: var(--success900);
    background-color: var(--success100);
  }

  .carrier {
    color: var(--accent900);
    background-color: var(--accent100);
  }

  .manual {
    color: var(--error900);
    background-color: var(--error100);
  }
`;
